import Cookies from 'js-cookie';
import Service from '../../service/Service';
const service = new Service();
var countimg = 0;
var countpdf = 0;
var img_flag = false;
var pdf_flag = false;
var file_array = [];
var commentDocUrl = "[]";
var isQuestion = false;

export function shareOn(id) {
    // debugger;
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    document.getElementById('share_' + id).getElementsByClassName('sharing-options')[0].style.display = 'block';
    if (window.innerWidth < 767) {
        if (document.getElementsByClassName('share-overlay')[0]) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'block';
        }
    }
}

 export function shareVideo(shareoption, articleurl) {
        var shareurl;
        let ary = document.getElementsByClassName('sharing-options');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
        if (document.getElementsByClassName('share-overlay')[0]) {
            document.getElementsByClassName('share-overlay')[0].style.display = 'none';
        }
        if (shareoption == "facebook") {
            shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
        } else if (shareoption == "twitter") {
            shareurl = 'https://twitter.com/share?url=';
        } else if (shareoption == "pintrest") {
            shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
        } else if (shareoption == "whatsapp") {
            shareurl = 'whatsapp://send?text=';
        }
        var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
        if (sharewindow.focus) {
            sharewindow.focus();
        }
        return false;
    }

export function getCategoryUrl(CategoryName) {
    return "https://parenting.firstcry.com/groups/"+service.replaceSymbols(CategoryName);
        // window.location.href = service.getRedirectUrl("/coloring-pages-printables/"+mainCat+"/"+subCat+"/"+ cat+"/");
}

export function shareArticle(shareoption, articleurl) {
    var shareurl;
    if (!articleurl.includes('http')) {
        articleurl = 'https:' + articleurl;
    }
    let ary = document.getElementsByClassName('sharing-options');
    for (let i = 0; i < ary.length; i++) {
        ary[i].style.display = 'none';
    }
    if (document.getElementsByClassName('share-overlay')[0]) {
        document.getElementsByClassName('share-overlay')[0].style.display = 'none';
    }
    if (shareoption == "facebook") {
        shareurl = 'https://www.facebook.com/sharer/sharer.php?u=';
    } else if (shareoption == "twitter") {
        shareurl = 'https://twitter.com/share?url=';
    } else if (shareoption == "pintrest") {
        shareurl = 'https://www.pinterest.com/pin/create/button/?url=';
    } else if (shareoption == "whatsapp") {
        shareurl = 'whatsapp://send?text=';
    }
    var sharewindow = window.open(shareurl + articleurl, shareoption + '-popup', 'height=350,width=600');
    if (sharewindow.focus) {
        sharewindow.focus();
    }
    return false;
}

function showFileError(mainClass, msg) {
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.visibility = "visible";
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.display = "inline-block";
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].innerHTML = msg;
    service.hideLoader();
}

function hideFileError(mainClass) {
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.visibility = "hidden";
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.display = "none";
    document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].innerHTML = "";
}

export function loadReadMore() {
    let readmoreAry = document.getElementsByClassName('readmore_popup');
    for (let i = 0; i < readmoreAry.length; i++) {
        let maxHeight = 80;
        if (readmoreAry[i].classList.contains('que-readmore')) {
            maxHeight = 96;
        }
        let dataId = readmoreAry[i].getAttribute('data-id');
        let divHeight = document.getElementById(dataId).offsetHeight;
        if (divHeight > maxHeight) {
            document.getElementById(dataId).style.height = maxHeight + 'px';
            readmoreAry[i].style.display = "inline-block";
        }
    }
}


 export function toggleQuest(event) {
        var el = event.target.parentElement;
        if(el.className !== "duedate-question"){
            el = el.parentElement;
            if(el.className == "heading"){
                el = el.parentElement;
            }
        }
         
        if (el.getElementsByClassName("arrow-down")[0].offsetWidth > 0) {
            
            [].forEach.call(document.querySelectorAll(".duedate-question"),function(ele){
                ele.querySelector("h2").style.margin = "0 0 0 0";
            });
            
            [].forEach.call(document.querySelectorAll(".duedate-answer"), function(ele){
                ele.style.display = "none";
            });
            
            [].forEach.call(document.querySelectorAll(".duedate-question .arrow-down"), function(ele){
                ele.style.display = "block";
            });

            [].forEach.call(document.querySelectorAll(".duedate-question .arrow-up"), function(ele){
                ele.style.display = "none";
            });
            
            el.querySelector("h2").style.margin = "0 0 10px 0";
            el.parentElement.querySelector(".duedate-answer").style.display = "block";
            el.querySelector(".duedate-question .arrow-down").style.display = "none";
            el.querySelector(".duedate-question .arrow-up").style.display = "block";
        } else {
            [].forEach.call(document.querySelectorAll(".duedate-question"),function(ele){
                ele.querySelector("h2").style.margin = "0 0 0 0";
            });

            el.parentElement.querySelector(".duedate-answer").style.display = "none";
            el.querySelector(".duedate-question .arrow-down").style.display = "block"
            el.querySelector(".duedate-question .arrow-up").style.display = "none"
        }
    }

    export function vaccinedescReadMore(event, dataId) {
        // //console.log(dataId);
        if (event.target.innerHTML == "Read More") {
            event.target.innerHTML = "Read Less";
            document.getElementById(dataId).style.maxHeight = 'inherit';
        } else {
            event.target.innerHTML = "Read More";
            let maxHeight = 62;
            document.getElementById(dataId).style.maxHeight = maxHeight + 'px';
        }
    }


 export function toggleDisc(event) {
        var el = event.target.parentElement;
        if(el.className !== "duedate-question"){
            el = el.parentElement;
            if(el.className == "duedate-btn-block"){
                el = el.parentElement;
            }
        }
         
        if (el.getElementsByClassName("arrow-down")[0].offsetWidth > 0) {
            el.parentElement.querySelector(".disclaimer-same-viewbt").style.display = "block";
            el.querySelector(".arrow-down").style.display = "none";
            el.querySelector(".arrow-up").style.display = "block";
        } else {
            el.parentElement.querySelector(".disclaimer-same-viewbt").style.display = "none";
            el.querySelector(".arrow-down").style.display = "block"
            el.querySelector(".arrow-up").style.display = "none"
        }
    }
   
    export function pisTestdone(e) {
    if (e.target.classList.contains('isChecked')) {
        e.target.classList.remove('isChecked');
        e.target.setAttribute('data-icon-font', "z");
    } else {
        e.target.value = 1;
        e.target.classList.add('isChecked');
        e.target.setAttribute('data-icon-font', "A");
    }
 }

 export function formatArticleDate(date) {
    let monthAry = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    let month = monthAry[new Date(date).getMonth()];
    let day = new Date(date).getDate() < 10 ? "0" + new Date(date).getDate() : new Date(date).getDate();
    let year = new Date(date).getFullYear();
    return day + " " + month ;
}
export function formatPeriodDate(date) {
    let monthAry = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
    let day = new Date(date).getDate() < 10 ? "0" + new Date(date).getDate() : new Date(date).getDate();
    return day ;
}

var num = "Zero One Two Three Four Five Six Seven Eight Nine Ten Eleven Twelve Thirteen Fourteen Fifteen Sixteen Seventeen Eighteen Nineteen".split(" ");
var tens = "Twenty Thirty Forty Fifty Sixty Seventy Eighty Ninety".split(" ");

export function number2words(n){
    if (n < 20) return num[n];
    var digit = n%10;
    if (n < 100) return tens[~~(n/10)-2] + (digit? " " + num[digit]: "");
}


export function likeArticle(artiID, e, likecount) {
    let cls = e.target;
    if (global.ftk !== '') {
        service.showLoader();
        var postData = {
            "articleId": artiID,
            "actionStatus": "1",
        }
        var url = global.api_ci_url + "personalizationFeed/likeArticle";
       
        service.postServiceCall(url, postData).then((json) => {
            service.hideLoader();
            if (json['result'] == "success") {
                // //console.log("eee",e)
                
                cls.parentElement.classList.add('active');
                cls.nextSibling.innerHTML = (++likecount) +" Likes";
            }

        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
        return true;
    } else {
            service.showAlert("Please Login");
            window.location.href = service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL);
            return false;
    }
}

export function saveVideoAction(id, e, type, status, likecount) {
    if (global.ftk !== '') {
        service.showLoader();
        let cls = e.target;
        if (type == "like") {
            service.showLoader();
        }
        let gender = 'NA';
        let genderNo = '';
        if (global.userAry['Sex'] && global.userAry['Sex'] != '') {
            gender = global.userAry['Sex'];
            genderNo = gender.toLowerCase() == 'male' ? 0 : 1;
        }
        let childAry = [];
        global.userAry['childData'] && global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'].forEach((child) => {
            let obj = {};
            obj["gender"] = child['Gender'].toLowerCase();
            obj["dob"] = child['DOB'];
            obj["childId"] = child['ChildId'];
            obj["childName"] = child['ChildName'];
            obj["childPic"] = child['childPhoto'];
            childAry.push(obj);
        })
        var postData = {
            "videoId": id,
            "action_type": type,
            "action_status": status.toString(),
            "userPic": global.userAry['userPhoto'],
            "userName": global.userAry['userName'],
            "userGender": genderNo,
            "childArr": childAry,
        }

        
        var url = global.api_ci_url + "personalizationFeed/videoAction";
        service.postServiceCall(url, postData).then((json) => {
            // //console.log(json);
            if (parseInt(json['msg']) == 1) {
                // this.changeData(id, type, status);
               

                cls.parentElement.classList.add('active');
                cls.nextSibling.innerHTML = (++likecount) +" Likes";
            } else {
                // service.showAlert("Fail");
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    } else {
        service.showAlert("Please Login");
        window.location.href = service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL);
        return false;
}
}


   


    export function saveAnsAction(status, queId, ansId, actionType, e, likecount) {
        let cls = e.target;
    if (status == 1) {
        if (actionType == 'abuse') {
            hideAllAbuse();
        }
        if (global.ftk != '') {
            if ((global.userAry['Sex'] == "" || global.userAry['Sex'] == null) && global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'].length >=1) {
                service.showAlert("Please Complete Your Profile");
                    window.location.href = '/my-account?URL=' + global.currentURL;
                    return false;
            } else {
            if (global.userAry['IsTryingToConceive'] == 1 || (global.userAry['childData']['UserChildList'] && global.userAry['childData']['UserChildList'].length > 0)) {
                service.showLoader();
                var postData = {
                    "action_status": status + "",
                    "action_type": actionType,
                    "answer_id": ansId + "",
                    "question_id": queId + "",
                    "userPic": global.userAry['userPhoto'],
                    "userName": global.userAry['userName'],
                    "childArr": global.userAry['childData']['UserChildList'],
                    "userGender": global.userAry['Sex'],
                    "IsTryingToConceive": global.userAry['IsTryingToConceive']
                }
                var url = global.api_ci_url + "qna/saveAnsAction";
                service.postServiceCall(url, postData).then((json) => {
                    // eleRef.reloadData(queId, ansId);
                    cls.classList.add('active');
                    cls.nextSibling.innerHTML = (++likecount) +" Likes";
                // cls.firstElementChild.innerHTML = (++likecount) + " Likes";
                    service.hideLoader();
                }).catch((error) => {
                    console.error(error);
                    service.hideLoader();
                });
                return true;
            } else {
                service.showAlert("Please Complete Your Child Profile");
                window.location.href = '/my-account?URL=' + global.currentURL;
                return false;
            }
        }
        } else {
            service.showAlert("Please Login");
            window.location.href = global.loginUrl + '?URL=' + global.currentURL;
            return false;
        }
    }
}

export function likeUserList(memoryId, postType, commentId, replyId, eleRef) {
    if (global.ftk != '') {
        postType != 2 && service.showLoader();
        var postData = {
            "memoryId": memoryId,
            "postType": postType,
            "reqReplyId": replyId,
            "commentId": commentId,
            "pageno": "1",
            "pagesize": "15"
        }
        var url = global.api_ci_url + "Memories/getmemorylikesparenting";
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                let data = json['result'];
                if (data.length > 0) {
                    document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('followers-title')[0].innerHTML = 'LIKES';
                    document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('like-list')[0].innerHTML = service.getUserListHTML(JSON.stringify(data));
                    document.getElementsByClassName('followers-overlay')[0].style.display = 'block';
                    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
                }
            } else {
                service.closeUserListPopup();
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function getAnswerLikeUsers(e,count, ansId) {
    if(count > 0){
    service.showLoader();
    var postData = {
        "pagesize": count,
        "pageno": 1,
        "answer_id": ansId
    }
    var url = global.api_ci_url + "qna/getAnswerLikeUsers";
    service.postServiceCall(url, postData).then((json) => {
        if (json['msg'] == "1") {
            let data = json['likedUserInfo'];
            if (data.length > 0) {
                document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('followers-title')[0].innerHTML = 'LIKES';
                document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('like-list')[0].innerHTML = service.getUserListHTML(JSON.stringify(data));
                document.getElementsByClassName('followers-overlay')[0].style.display = 'block';
                document.getElementsByTagName('body')[0].style.overflow = 'hidden';
            }
        } else {
            service.closeUserListPopup();
            service.showAlert("Fail");
        }
        service.hideLoader();
    }).catch((error) => {
        console.error(error);
        service.hideLoader();
    });
}
}

export function getAnswerLikeUsersArticle(e, ansId, count) {

     if (global.ftk != '') {
         service.showLoader();
         var postData = {
            "pagesize": count,
            "pageno": 1,
            "recordId": ansId,
            "postType":2
        }
    var url = global.api_ci_url + "PersonalizationFeed/getArticleLikes";
        service.postServiceCall(url, postData).then((json) => {
            if (json['msg'] == "1") {
                let data = json['result'];
                if (data.length > 0) {
                    document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('followers-title')[0].innerHTML = 'LIKES';
                    document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('like-list')[0].innerHTML = service.getUserListHTML(JSON.stringify(data));
                    document.getElementsByClassName('followers-overlay')[0].style.display = 'block';
                    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
                }
            } else {
                service.closeUserListPopup();
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }


  /*  service.showLoader();
    var postData = {
        "pagesize": count,
        "pageno": 1,
        "recordId": ansId,
        "postType":2
    }
    var url = global.api_ci_url + "PersonalizationFeed/getArticleLikes";
    service.postServiceCall(url, postData).then((json) => {
        if (json.msg == "1") {
            let data = json.response.result;
            if (data.length > 0) {
                document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('followers-title')[0].innerHTML = 'LIKES';
                document.getElementsByClassName('followers-overlay')[0].getElementsByClassName('like-list')[0].innerHTML = service.getUserListHTML(JSON.stringify(data));
                document.getElementsByClassName('followers-overlay')[0].style.display = 'block';
                document.getElementsByTagName('body')[0].style.overflow = 'hidden';
            }
        } else {
            service.closeUserListPopup();
            service.showAlert("Fail");
        }
        service.hideLoader();
    }).catch((error) => {
        console.error(error);
        service.hideLoader();
    });*/
}






export function closeUserlist(event) {
    if (event.target.classList.contains('followers-overlay') || event.target.classList.contains('closeButton')) {
        service.closeUserListPopup();
    }
}


  export function time_ago(time) {

    switch (typeof time) {
      case 'number':
        break;
      case 'string':
        time = +new Date(time);
        break;
      case 'object':
        if (time.constructor === Date) time = time.getTime();
        break;
      default:
        time = +new Date();
    }
    var time_formats = [
      [60, 'seconds', 1], // 60
      [120, '1 minute ago', '1 minute from now'], // 60*2
      [3600, 'minutes', 60], // 60*60, 60
      [7200, '1 hour ago', '1 hour from now'], // 60*60*2
      [86400, 'hours', 3600], // 60*60*24, 60*60
      [172800, 'Yesterday', 'Tomorrow'], // 60*60*24*2
      [604800, 'days', 86400], // 60*60*24*7, 60*60*24
      [1209600, 'Last week', 'Next week'], // 60*60*24*7*4*2
      [2419200, 'weeks', 604800], // 60*60*24*7*4, 60*60*24*7
      [4838400, 'Last month', 'Next month'], // 60*60*24*7*4*2
      [29030400, 'months', 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
      [58060800, 'Last year', 'Next year'], // 60*60*24*7*4*12*2
      [2903040000, 'years', 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      [5806080000, 'Last century', 'Next century'], // 60*60*24*7*4*12*100*2
      [58060800000, 'centuries', 2903040000] // 60*60*24*7*4*12*100*20, 60*60*24*7*4*12*100
    ];
    var seconds = (+new Date() - time) / 1000,
      token = 'ago',
      list_choice = 1;
  
    if (seconds == 0) {
      return 'Just now'
    }
    if (seconds < 0) {
      seconds = Math.abs(seconds);
      token = 'from now';
      list_choice = 2;
    }
    var i = 0,
      format;
    while (format = time_formats[i++])
      if (seconds < format[0]) {
        if (typeof format[2] == 'string')
          return format[list_choice];
        else
          return Math.floor(seconds / format[2]) + ' ' + format[1] + ' ' + token;
      }
    return time;
  }

export function cmtFileDelete(type, key, eleRef) {
       // //console.log("eleRef========",eleRef);
        let mainEle = document.getElementsByClassName("addAns-overlay-feed")[0];
        let mainClass = 'addAns-overlay-feed';
        if (key == "que") {
            mainEle = document.getElementsByClassName("askQuest-overlay")[0];
            mainClass = 'askQuest-overlay';
        }
        // actions.hideFileError(mainClass);
        document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.visibility = "hidden";
        document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].style.display = "none";
        document.getElementsByClassName(mainClass)[0].getElementsByClassName('file_upload_err')[0].innerHTML = "";
        for (var i = 0; i < file_array.length; i++) {
            if (type == 'pdf') {
                if (file_array[i]['url'].split('.').pop() == 'pdf') {
                    file_array.splice(i, 1);
                }
            } else {
                if (file_array[i]['url'].split('.').pop() != 'pdf') {
                    file_array.splice(i, 1);
                }
            }
        }
        commentDocUrl = JSON.stringify(file_array);
        document.getElementById("fileupload").value = '';
        var fileEle = mainEle.getElementsByClassName('uploaded-files-list')[0];
        
        if (type == "pdf") {
            countpdf--;
            pdf_flag = false;
            fileEle.getElementsByClassName('cmt-pdf')[0].style.display = "none";
            fileEle.getElementsByClassName('cmt-pdf')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
        } else {
            countimg--;
            img_flag = false;
            fileEle.getElementsByClassName('cmt-image')[0].style.display = "none";
            document.getElementById("fileupload").value = '';
            fileEle.getElementsByClassName('cmt-image')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
        }
        eleRef.setState({docUrl:''});
    }

    export function openPopupPersonalised(url,eleRef){
        document.querySelector(".addAns-overlay.popup").style.display="block";
        // //console.log("url---",url);
      
            eleRef.setState({
                popupurl:url
            })
    }
    export function OnPopupSubmit(){
        // //console.log(document.getElementById('child_date').value);
        // //console.log(document.getElementById('child-name').value);
        if(document.getElementById('child_date').value == ""){
            document.getElementsByClassName('child_enter_correct_dates')[0].style.display = "block";
            document.getElementsByClassName('child_enter_correct_dates')[0].innerHTML = "Please Enter Date";
            return false;
        }
       else if(document.getElementById('child-name').value == ""){
            document.getElementsByClassName('child_enter_correct_name')[0].style.display = "block";
            document.getElementsByClassName('child_enter_correct_dates')[0].style.display = "none";
            document.getElementsByClassName('child_enter_correct_name')[0].innerHTML = "Please Enter Name";
            return false;
    }
    else { 
        window.location.href=global.loginUrl + '?URL=' + global.currentURL}
    
}
export function OnChoosePopupSubmit(){
    if(document.getElementById('child_DueDate').value == ""){
        document.getElementsByClassName('child_enter_correct_date')[0].style.display = "block";
        document.getElementsByClassName('child_enter_correct_date')[0].innerHTML = "Please Enter Due Date";
        return false;
    }
    else { window.location.href=global.loginUrl + '?URL=' + global.currentURL}

}

    export function openChoosePopupPersonalised(url,eleRef){
        document.querySelector(".addAns-overlay.choose").style.display="block";
        // //console.log("url---",url);
        // if(getAttribute("data-id")=="infant"){
        //     //console.log("inside popup");
        //     <a href="/infant-0-6-months#infant"></a>
        //     }

        //     if(url="/infant-0-6-months"){
        //         //console.log("inside infant div");
        //     }
            eleRef.setState({
                popupurl:url
            })
    }
   

   
    
    export function closePopupcommon(eleRef){
        // document.querySelector(".popUpClose").style.display="none"; 
      

       // <a href="/infant-0-6-months#infant"></a>
        if(eleRef.state.popupurl=='/infant-0-6-months'){
            window.location.href= 'infant-0-6-months';
        }
        if(eleRef.state.popupurl=='/baby-0-2-years'){
            window.location.href= 'baby-0-2-years';
        }
        
        if(eleRef.state.popupurl=='/toddler-2-4-years'){
            window.location.href= 'toddler-2-4-years';
        }
        if(eleRef.state.popupurl=='/kid-4-plus-years'){
            window.location.href= 'kid-4-plus-years';
        }
        if(eleRef.state.popupurl=='/trying-to-conceive'){
            window.location.href= 'trying-to-conceive';
        }
        if(eleRef.state.popupurl=='/big-kid-6-plus-years'){
            window.location.href= 'big-kid-6-plus-years';
        }
        if(eleRef.state.popupurl=='/expecting'){
            window.location.href= 'expecting';
        }
    }

export function openAnswerPopup(question_id,userPhoto,username,childInfoReq,answer_type,question_type,que_type,question_creater_id,answer_details,expectedDob,user_type,qnaUserType,eleRef){
    if(global.ftk != ""){
    document.querySelector(".addAns-overlay.feed").style.display="block";

    var fileEle = document.getElementsByClassName('addAns-overlay-feed')[0].getElementsByClassName('uploaded-files-list')[0];
    document.getElementById("fileupload").value = "";
    document.getElementById('postAnscomment').value = "";
    fileEle.getElementsByClassName('cmt-image')[0].style.display = "";
    fileEle.getElementsByClassName('cmt-image')[0].getElementsByClassName('added-file-name')[0].innerHTML = "";
    img_flag = false;

    
    // //console.log("openAnswerPopup eleRef",eleRef.state.userName);
    // //console.log("openAnswerPopup eleRef qid",eleRef.state.question_id);
    
    eleRef.setState({
        username: username,
        question_id:question_id,
        userPhoto:global.userAry['userPhoto'],
        childInfoReq:global.userAry['childData']['UserChildList'],
        docUrl:'',
        answer_type:answer_type,
        question_type:question_type,
        que_type:'',
        question_creater_id:question_creater_id,
        answer_details:'',
        expectedDob:expectedDob,
        user_type:user_type,
        qnaUserType:qnaUserType,
        })
    //console.log("global.userAry['childData']['UserChildList']",global.userAry['childData']['UserChildList']);
    // //console.log("global.userAry",global.userAry.expectedDob)
    // //console.log("direct u name : ",username);
    // //console.log("user photo",userPhoto)
    // //console.log(question_id);
    // //console.log(eleRef.state.answer_details);
    // //console.log("global.userAry",global.userAry)
    }
    else {
        service.showAlert("Please Login");
        window.location.href = service.getRedirectUrl(global.loginUrl + '?URL=' + global.currentURL);
        return false;
}
    // //console.log("eleRef.state.userName ",eleRef.state.userName);
} 
export function openprofilePopup(){
    if(global.ftk != ""){
    document.querySelector(".select_child_popup").style.display="block";

    }
}

// export function showChildFeed(eleRef,id, chId, chDob, chName, chGender, userExpecting, e, NumOfdays, callfunctionFrom = 2){
//     eleRef.setState({
//         selected_child_id:chId,
       
//     })
//     var childProfileData = eleRef.state.childProfileData.childArr;
//     //console.log("eleRef.state.childProfileData.childArr",eleRef.state.childProfileData.childArr)
//     //var childArr=this.state.feedProfile;
//         for(var k=0;k<childProfileData.length;k++){
//             if(childProfileData[k]['childId']==chId){
//                 if(childProfileData[k].isExpecting!=1){
//                     if((childProfileData[k].age.year == 0 && (childProfileData[k].age.month > 6 || childProfileData[k].age.month == 6)) || ((childProfileData[k].age.year != 0 && childProfileData[k].age.year < 2) || (childProfileData[k].age.year == 2 && childProfileData[k].age.month < 1))  ){
//                         service.showLoader();
//                        eleRef.setState({
//                         selectedChild:childProfileData[k]
//                        })
//                        //service.hideLoader();
//                     }
//                     else{
//                         document.getElementsByClassName('childProfile_overlay2')[0].style.display = 'block';
//                     }
//                 }else if(childProfileData[k].isExpecting==1){
//                     service.showLoader();
//                     eleRef.setState({
//                         selectedChild:childProfileData[k]
//                        })
                       
//                 }
//             }
            
//         }
//         document.querySelector('.select_child_popup.addAns-overlay').style.display="none";
    
// }



export function addPost(eleRef) {
    if (global.ftk != '') {
        // service.showLoader();
        var postData = {};
        var url = '';
        var msg = document.getElementById('postcomment') ? document.getElementById('postcomment').value : "";
        // //console.log("msg --",msg)
        if (msg && msg != "") {
            document.getElementsByClassName('memory-cmt-err')[0].style.display = "none";
            document.getElementsByClassName('memory-cmt-err')[0].innerHTML = "";
            if (eleRef.state.commentType == "reply") {
                postData = {
                    "memoryId": eleRef.state.postMemoryId,
                    "commentId": eleRef.state.postCommentId,
                    "reply": msg,
                    "userType": getUserGender(global.userAry['Sex']),
                    "userGender": getUserGender(global.userAry['Sex']),
                    "userName": global.userAry['userName'],
                    "userPic": global.userAry['userPhoto'],
                    "childArr": getChildPostAry(global.userAry['childData']['UserChildList']),
                    "postType": "1",
                    "captchaResponseToken": ""
                }
                url = global.api_ci_url + "Memories/postreply";
            } else {
                postData = {
                    "memoryId": eleRef.state.postMemoryId,
                    "comment": msg,
                    "userType": getUserGender(global.userAry['Sex']),
                    "userGender": getUserGender(global.userAry['Sex']),
                    "userName": global.userAry['userName'],
                    "userPic": global.userAry['userPhoto'],
                    "childArr": getChildPostAry(global.userAry['childData']['UserChildList']),
                    "postType": "1",
                    "captchaResponseToken": ""
                }
                url = global.api_ci_url + "Memories/postcomment";
            }
            // //console.log("postDatapostData ---",postData)
            service.postServiceCall(url, postData).then((json) => {
                // //console.log("add post : ", json);
                if (json['msg'] == "1") {
                    // //console.log("comment posted");
                    // start
                    // //console.log("eleRef.state.communityHome",eleRef.state.communityHome);
                        var communityHome = eleRef.state.communityHome;
                        var letestcommunityHome = [];
                        communityHome && communityHome.forEach((HFeed) => {

                            if(HFeed.type=="memoriesview"){

                                if(HFeed.data && HFeed.data[0].memoryId==eleRef.state.postMemoryId){
                                    // let qnaFedd = HFeed;
                                    HFeed.data[0].comments.push({
                                        abuseStatus: 0,
                                        comment: msg,
                                        commentCreatorId: global.userAry['userid'],
                                        commentDate: "2 hours ago",
                                        commentId: '',
                                        isAbuse: false,
                                        is_specialist: false,
                                        is_specialist_available: false,
                                        userDesc: "",
                                        userDetailDesc: "",
                                        userGender: global.userAry['Gender'],
                                        userName: global.userAry['userName'],
                                        userPic: global.userAry['userPhoto']
                                    });

                                    letestcommunityHome.push(HFeed);

                                }else{
                                    letestcommunityHome.push(HFeed);
                                }


                            }else{
                                letestcommunityHome.push(HFeed);
                            }

                        });
                        eleRef.setState({ communityHome: letestcommunityHome })
                        // //console.log("after update",eleRef.state.communityHome)


                    // end
                   // eleRef.appendPost(eleRef.state.postMemoryId, eleRef.state.postCommentId);
                    closePopupcommon2();
                }
                service.hideLoader();
            }).catch((error) => {
                console.error(error);
                service.hideLoader();
            });
        } else {
            var errMsg = "Please Enter Comment Text";
            if (eleRef.state.commentType == "reply") {
                errMsg = "Please Enter Reply Text";
            }
            document.getElementsByClassName('memory-cmt-err')[0].style.display = "inline-block";
            document.getElementsByClassName('memory-cmt-err')[0].innerHTML = errMsg;
            service.hideLoader();
        }
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

export function likePost(memoryId, status, postType, commentId, replyId, eleRef,e,likecount) {
    let cls = e.target;
    if (global.ftk != '') {
        service.showLoader();
        var postData = {
            "memoryId": memoryId,
            "postType": postType,
            "status": status,
            "reqReplyId": replyId,
            "commentId": commentId,
            "userName": global.userAry['userName'],
            "userPic": global.userAry['userPhoto'],
            "userGender": getUserGender(global.userAry['Sex']),
            "childArr": getChildPostAryUpload(global.userAry['childData']['UserChildList'])
        }
        var url = global.api_ci_url + "Memories/likepost";
        service.postServiceCall(url, postData).then((json) => {
            // //console.log(json);
            if (parseInt(json['msg']) == 1) {

                cls.classList.add('active');
                document.getElementById('like_'+memoryId).innerHTML = (++likecount) +" Likes";

                /*var memoryData = eleRef.state.memoryData;

                memoryData && memoryData.forEach((memory) => {
                    if ((postType == 0 && memory.memoryId == memoryId) ||
                        (postType == 1 && memory.commentId == commentId) ||
                        (postType == 2 && memory.replyId == replyId)) {
                        memory.isLiked = status;
                        if (status == 1) {
                            memory.likeCount = parseInt(memory.likeCount) + 1;
                        } else if (status == 0) {
                            memory.likeCount = parseInt(memory.likeCount) - 1;
                        }
                    }
                });
                eleRef.setState({ memoryData: memoryData })*/
            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}

function getUserGender(gender) {
    var genderint = 2;
    gender = gender ? gender.toLowerCase() : '';
    if (gender == 'male') {
        genderint = 0;
    } else if (gender == 'female') {
        genderint = 1;
    }
    return genderint;
}

function getChildPostAry(reqAry) {
    let resAry = [];
    for (let c = 0; c < reqAry.length; c++) {
        let obj = {};
        obj['childId'] = reqAry[c]['ChildId'];
        obj['childName'] = reqAry[c]['ChildName'];
        obj['gender'] = reqAry[c]['Gender'];
        obj['dob'] = reqAry[c]['DOB'];
        obj['childPic'] = reqAry[c]['childPhoto']
        resAry.push(obj);
    }
    return resAry;
}

function getChildPostAryUpload(reqAry) {
    let resAry = [];
    for (let c = 0; c < reqAry.length; c++) {
        let obj = {};
        obj['childId'] = reqAry[c]['ChildId'];
        obj['childName'] = reqAry[c]['ChildName'];
        obj['gender'] = reqAry[c]['Gender'];
        obj['dob'] = reqAry[c]['DOB'];
        obj['childPic'] = reqAry[c]['childPhoto']
        resAry.push(obj);
    }
    return resAry;
}

export function openCommentPopup(memoryId, type, commentId, eleRef) {
    // //console.log("open comment popup",eleRef);
    if (global.ftk != '') {
        document.getElementById('postcomment').value = "";
        document.querySelector(".addReply-overlay.feedComment").style.display = "block";

        eleRef.setState({
            commentType: type,
            postMemoryId: memoryId,
            postCommentId: commentId
        });


    } else {
        service.showAlert("Please Login");
        window.location.href = global.loginUrl + '?URL=' + global.currentURL;
        return false;
    }
}



export function showAddEditPopup(){
    document.querySelector(".popUpPersonalised").style.display="block";
} 

export function showLikePopup(){
    document.querySelector(".likes-overlay.feeds").style.display="block";
} 
export function closePopupcommon2(){
    document.querySelector(".popUpPersonalised").style.display="none";
    document.querySelector(".popUpPersonalised.addAns-overlay").style.display="none";
    // document.querySelector(".popUpPersonalised.addAns-overlay.nonLog").style.display="none";
    document.querySelector(".select_child_popup.addAns-overlay").style.display="none";
    document.querySelector(".addPost-overlay.feedComment").style.display="none";
     document.querySelector(".addAns-overlay.feed").style.display="none";
} 


export function cmtFileUpload(eleRef) {
    var mainClass = 'addAns-overlay-feed';
    if (isQuestion) {
        mainClass = 'askQuest-overlay';
    }
    var fileObj = document.getElementById("fileupload").files[0];
    var fname = Math.round(new Date().getTime() / 1000) + "_" + new Date().getTime();
    var file_name = "";
    var apiurl = "";
    if(!fileObj){
        return;
    }
    if(navigator.onLine){
        service.showLoader();
        if ((fileObj.type == "image/jpg" || fileObj.type == "image/jpeg" || fileObj.type == "image/png") && fileObj.size < 2097152) {
            file_name = Math.round(new Date().getTime() / 1000) + "_" + new Date().getTime() + ".jpg";
            // //console.log("file_name",file_name);
            img_flag = true;
            countimg++;
            // //console.log("counting",countimg);
            apiurl = global.api_ci_url + "PersonalizationFeed/uploadMemoryImage";
            // //console.log("apiurl",apiurl)
            // //console.log("before --- ",eleRef);
                service.postFileServiceCall(apiurl, fileObj, file_name).then((json) => {
                // //console.log(json)
                if (json["result"] == 'success') {
                    
                    eleRef.setState({
                        docUrl:json["image_url"]
                    })
                    file_array.push({
                        "url": json["image_url"],
                        "height": 10,
                        "width": 10
                    });
                    
                    commentDocUrl = JSON.stringify(file_array);
                    // //console.log("commentDocUrl",commentDocUrl);                   
                    var fileEle = document.getElementsByClassName(mainClass)[0].getElementsByClassName('uploaded-files-list')[0];
                    if (fileObj.type == "application/pdf") {
                        fileEle.getElementsByClassName('cmt-pdf')[0].style.display = "list-item";
                        fileEle.getElementsByClassName('cmt-pdf')[0].getElementsByClassName('added-file-name')[0].innerHTML = fileObj.name;
                        pdf_flag = false;
                    } else {
                        fileEle.getElementsByClassName('cmt-image')[0].style.display = "list-item";
                        fileEle.getElementsByClassName('cmt-image')[0].getElementsByClassName('added-file-name')[0].innerHTML = fileObj.name;
                        img_flag = false;
                    }
                    // debugger;
                    document.getElementById("fileupload").value = '';
                } else {
                    service.showAlert("Fail");
                }
                service.hideLoader();
            }).catch((error) => {
                if (fileObj.type == "application/pdf") {
                    countpdf = 0;
                    pdf_flag = false;
                } else {
                    countimg = 0;
                    img_flag = false;
                }
                service.showAlert("File too large or something went wrong");
                console.error(error);
                service.hideLoader();
            });




        }else if (fileObj.type == "application/pdf" && fileObj.size < 2097152) {
            file_name = Math.round(new Date().getTime() / 1000) + "_" + new Date().getTime() + ".pdf";
            pdf_flag = true;
            countpdf++;
            // //console.log("in pdf");
            apiurl = global.api_ci_url + "PersonalizationFeed/uploadMemoryImage";

        
        // else if (fileObj.type == "application/pdf" && fileObj.size < 2097152) {
        //     file_name = Math.round(new Date().getTime() / 1000) + "_" + new Date().getTime() + ".pdf";
        //     pdf_flag = true;
        //     countpdf++;
        //     apiurl = global.api_ci_url + "PersonalizationFeed/uploadMemoryImage";
        // } else {
        //     // countimg = 0;
        //     // countpdf = 0;
        //     apiurl = "";
        //     showFileError(mainClass, "Only JPEG, JPG, PNG and PDF files allowed of less than 2 MB");
        //     return;
        // }
        // if ((img_flag && countimg == 1) || (pdf_flag && countpdf == 1)) {
            // hideFileError(mainClass);
            service.postFileServiceCall(apiurl, fileObj, file_name).then((json) => {
                // //console.log(json)
                if (json["result"] == 'success') {
                    
                    eleRef.setState({
                        docUrl:json["image_url"]
                    })
                    file_array.push({
                        "url": json["image_url"],
                        "height": 10,
                        "width": 10
                    });
                    
                    commentDocUrl = JSON.stringify(file_array);
                    // //console.log("commentDocUrl",commentDocUrl);                   
                    var fileEle = document.getElementsByClassName(mainClass)[0].getElementsByClassName('uploaded-files-list')[0];
                    if (fileObj.type == "application/pdf") {
                        fileEle.getElementsByClassName('cmt-pdf')[0].style.display = "list-item";
                        fileEle.getElementsByClassName('cmt-pdf')[0].getElementsByClassName('added-file-name')[0].innerHTML = fileObj.name;
                        pdf_flag = false;
                    } else {
                        fileEle.getElementsByClassName('cmt-image')[0].style.display = "list-item";
                        fileEle.getElementsByClassName('cmt-image')[0].getElementsByClassName('added-file-name')[0].innerHTML = fileObj.name;
                        img_flag = false;
                    }
                    // debugger;
                    document.getElementById("fileupload").value = '';
                } else {
                    service.showAlert("Fail");
                }
                service.hideLoader();
            }).catch((error) => {
                if (fileObj.type == "application/pdf") {
                    countpdf = 0;
                    pdf_flag = false;
                } else {
                    countimg = 0;
                    img_flag = false;
                }
                service.showAlert("File too large or something went wrong");
                console.error(error);
                service.hideLoader();
            });
        }
         else {
            if(countimg > 1){
                // //console.log("else",countimg)
                countimg--;
                img_flag = false;
            }
            if(countpdf > 1){
                // //console.log("else",countimg)
                countpdf--;
                pdf_flag = false;
            }
            showFileError(mainClass, "Only 1 image can be uploaded & only 1 pdf can be uploaded");
            service.hideLoader();
            return;
        }
    } else {
        document.getElementById("fileupload").value = '';
        service.showAlert("Please check internet connection");
    }
}


export function postParentingAnswer(question_id,userPhoto,username,childInfoReq,docUrl,answer_type,question_type,que_type,question_creater_id,answer_details,expectedDob,user_type,qnaUserType,eleRef){

    var comment = document.getElementById('postAnscomment') ? document.getElementById('postAnscomment').value : "";
    if(comment !=""){
    // api ci url  postParentingAnswer
    var url = global.api_ci_url + "PersonalizationFeed/postParentingAnswer";

    var postdata = {                 
        "question_id":question_id,
        "pic_url": global.userAry['userPhoto'],
        "user_name":username,
        "childinfo":global.userAry['childData']['UserChildList'],
        "docUrls":eleRef.state.docUrl,
        "answer_type":answer_type,
        "question_type":question_type,
        "que_type":'child',
        "question_creater_id":question_creater_id,
        "answer_details":comment,
        "expecting_dob":global.userAry.expectedDob,
        "user_type":1,
        "qnaUserType":1
    }   
    //console.log(postdata);
    service.postServiceCall(url, postdata).then((json) => {
        // //console.log("inside service");
        // //console.log('postAnswerurl',json)
        if (json['response']['success'] == "1") {
            
            closePopupcommon2()
           
            // //console.log(comment); 
            
            
            // //console.log("eleRef.state.communityHome",eleRef.state.communityHome);
                        var communityHome = eleRef.state.communityHome;
                        var letestcommunityHome = [];
                        communityHome && communityHome.forEach((HFeed) => {



                           if(HFeed.type=="qna"){



                               if(HFeed.data && HFeed.data[0].question_id==eleRef.state.question_id){
                                    // let qnaFedd = HFeed;
                                    HFeed.data[0].answers.push({
                                        acid: global.userAry['mycid'],
                                        ansCreatedDate: "1 min ago",
                                        ans_abuse: false,
                                        ans_abuse_count: 0,
                                        ans_creater_id: '',
                                        ans_is_specialist: false,
                                        ans_like: false,
                                        ans_like_count: 0,
                                        ans_permant_abuse: 0,
                                        ans_posted_time: "",
                                        ans_question_type: 1,
                                        ans_user_description: "Trying To Conceive",
                                        ans_user_description_detail: "Trying To Conceive",
                                        ans_user_gender: null,
                                        ans_user_name: global.userAry['userName'],
                                        ans_user_type: "NA",
                                        ans_userpic: global.userAry['userPhoto'],
                                        answer_details: comment,
                                        answer_id: json['response']['answerId'],
                                        answer_type: 0,
                                        badges: "",
                                        cs: "0",
                                        is_specialist_available: false,
                                        level: "",
                                        point: "",
                                        rank: "",
                                        topBadges: [],
                                        urls: []
});


document.getElementById('icon-colour').className = "pink-text";
                                   letestcommunityHome.push(HFeed);



                               }else{
                                    letestcommunityHome.push(HFeed);
                                }




                            }else{
                                letestcommunityHome.push(HFeed);
                            }



                       });
                        eleRef.setState({ communityHome: letestcommunityHome })
                        // //console.log("after update",eleRef.state.communityHome)
            
        
        }
       
        service.hideLoader();
    }).catch((error) => {
        // this.setState({ 
        //     postAnswerurl : []
        //     });
        console.error(error);
        service.hideLoader();
    });
    } else {
        var errMsg = "Please Enter Answer Text";
        
        document.getElementsByClassName('postansErrormsg')[0].visibility = "inherit";
        // document.getElementsByClassName('memory-cmt-err')[0].innerHTML = errMsg;
        service.hideLoader();
    }

}


export function saveParentingQueActions(que_follow,creater_id,question_id,question_title,question_type,follow_count,eleRef){
    // var que_follow = true;
    if (global.ftk !== '') {
        service.showLoader();
    if(que_follow){
    var action_status = 0;
    }else{
    var action_status = 1;
    }
    var url = global.api_ci_url + "PersonalizationFeed/saveParentingQueActions";
    
   

    var postdata = {  
                "childinfo":global.userAry['childData']['UserChildList'],
                 "question_type":question_type,
                 "action_status":action_status,
                 "action_type":"follow",
                 "creater_id":creater_id,
                 "question_id":question_id,
                 "user_type":global.userAry['Sex'],
                 "que_type":"child", 
                "question_title":question_title,
                "expecting_dob":global.userAry.expectedDob,
                "is_user_desk":global.isdesktop
     }
     service.postServiceCall(url, postdata).then((json) => {
        if (json) {
            if(que_follow){
                eleRef.setState({
                    que_follow:false,
                    follow_count:follow_count-1
                })
            }
            else{
                eleRef.setState({
                    que_follow:true,
                    follow_count:follow_count+1
                })
            }

            eleRef.setState({
                question_id:question_id
            })
            
            service.hideLoader();
            // //console.log("eleRef.state.communityHome",eleRef.state.communityHome);
            var communityHome = eleRef.state.communityHome;
            var letestcommunityHome = [];       
            communityHome && communityHome.forEach((HFeed) => {



               if(HFeed.type=="qna"){



                   if(HFeed.data && HFeed.data[0].question_id==eleRef.state.question_id){
                  //  que_follow=eleRef.state.que_follow
                       // let qnaFedd = HFeed;
        //                 HFeed.data[0].push({
        //                     que_follow: eleRef.state.que_follow,
        // })            
                       
                       HFeed.data[0].que_follow = eleRef.state.que_follow;
                       HFeed.data[0].follow_count = eleRef.state.follow_count;
    letestcommunityHome.push(HFeed);



}else{
     letestcommunityHome.push(HFeed); }




}else{
 letestcommunityHome.push(HFeed);
}



});
eleRef.setState({ communityHome: letestcommunityHome })
// //console.log("after update",eleRef.state.communityHome)


}

service.hideLoader();
}).catch((error) => {
// this.setState({ 
//     postAnswerurl : []
//     });
console.error(error);
service.hideLoader();
});


    //  success 
    // if(que_follow){
    //     var que_follow_state = 0;
    //     }else{
    //     var que_follow_state = 1;
    //     }
    // end 
}else {
    service.showAlert("Please Login");
    window.location.href = global.loginUrl + '?URL=' + global.currentURL;
    return false;
}

}

// export function saveAbuseAction(memoryId,isAbuse,eleRef){
//     // var userid=global.userAry['childData']['UserMaster']['UserID'];
//     // //console.log(userid);
//     // //console.log(global.userAry)
//     if (global.ftk !== '') {
//         service.showLoader();
//     //console.log("eleRef.state.isAbuse before",eleRef.state.isAbuse)
//     var url = global.api_ci_url + "PersonalizationFeed/saveAbuseAction";
//     var postdata={}
//     var postType=0;
//     if(isAbuse){
//         var abuse_status = 0;
//         }else{
//         var abuse_status = 1;
//         }
//     if(postType==0){
//      postdata = {  
//         "memoryId":memoryId,
//         "postType": postType,
//          "reqReplyId": "",
//          "commentId": "",
//          "userPic":global.userAry['userPhoto'],
//          "userName": global.userAry['userName'],
//          "userId": global.userAry['childData']['UserMaster']['UserID'],
//          "userGender": global.userAry['Sex'],
//          "childArr":global.userAry['childData']['UserChildList'],
//          "status":abuse_status
//     }
// }else{

//     postdata = {  
//         "memoryId":memoryId,
//         "postType": postType,
//          "reqReplyId": "",
//          "commentId": "",
//          "userPic":global.userAry['userPhoto'],
//          "userName": global.userAry['userName'],
//          "userId": global.userAry['userid'],
//          "userGender": global.userAry['Sex'],
//          "childArr":global.userAry['childData']['UserChildList'],
//          "status":"1"
//     }

// }

// service.postServiceCall(url, postdata).then((json) => {
//     //console.log(json)
//     if (parseInt(json['response']['msg']) == 1) {

//         if (json) {
//             if(isAbuse){
//                 eleRef.setState({
//                     isAbuse:false
//                 })
//             }
//             else{
//                 eleRef.setState({
//                     isAbuse:true
//                 })
//             }
            
//             //console.log("eleRef.state.isAbuse after",eleRef.state.isAbuse)
//             eleRef.setState({
//                 memoryId:memoryId
//             })
//             //console.log("============ eleRef.state.memoryId",eleRef.state.memoryId)
//             service.hideLoader();
//             //console.log("eleRef.state.communityHome",eleRef.state.communityHome);
//             var communityHome = eleRef.state.communityHome;
//             var letestcommunityHome = [];       
//             communityHome && communityHome.forEach((HFeed) => {
//                if(HFeed.type=="memoriesview"){
//                    if(HFeed.data && HFeed.data[0].memoryId==eleRef.state.memoryId){
//                   //  que_follow=eleRef.state.que_follow
//                        // let qnaFedd = HFeed;
//         //                 HFeed.data[0].push({
//         //                     que_follow: eleRef.state.que_follow,
//         // })            
                       
//                        HFeed.data[0].isAbuse = eleRef.state.isAbuse;
//     letestcommunityHome.push(HFeed);
// }else{
//      letestcommunityHome.push(HFeed); 
//     }
// }else{
//  letestcommunityHome.push(HFeed);
// }



// });
// eleRef.setState({ communityHome: letestcommunityHome })
// //console.log("after update",eleRef.state.communityHome)

//         }

//     }

//     service.hideLoader();
// }).catch((error) => {
// // this.setState({ 
// //     postAnswerurl : []
// //     });
// console.error(error);
// service.hideLoader();
// });

//     }else {
//         service.showAlert("Please Login");
//         window.location.href = global.loginUrl + '?URL=' + global.currentURL;
//         return false;
//     }

// }

export function setWeekByWeekImage(tabType, image,eleRef){
    // let cls = e.target;
    // //console.log("in fun image",image);
    eleRef.setState({
        weekbyweekFetalImage:image,
        weekbyweekFetalActive:tabType
    });

    

    
    // cls.classList.add('active');

    // //console.log("in fun state",eleRef.state.weekbyweekFetalImage);

}



export function babycomparisonImage(tabType, image,sizename,eleRef){
    // let cls = e.target;
    // //console.log("in fun image",image);
    eleRef.setState({
        babycomparisonImage:image,
        babycomparisonActive:tabType,
        sizename:sizename
    });
}
export function expectedProfile(expectedTabType,eleRef){
    eleRef.setState({
        expectedTab:expectedTabType
    });
}

export function domClick(event) {
    if (event.target.classList.contains('likelist-follow')) {
        service.followUserAction(1, event.target.getAttribute('data-id'));
    }
    if (event.target.classList.contains('likelist-unfollow')) {
        service.followUserAction(0, event.target.getAttribute('data-id'));
    }
    if (!event.target && !event.target.matches('.socialShare') && !event.target.matches('.m-abuse-main') && !event.target.matches('.share-other-div') && !event.target.matches('.share-parenting')) {
       /* let ary = document.getElementsByClassName('sharing-options');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }*/
    }
    if(event.target.classList.contains('select_child_popup')){
        document.getElementsByClassName('select_child_popup')[0].style.display = 'none';
    }
    if(event.target.classList.contains('choose')){
        document.getElementsByClassName('choose')[0].style.display = 'none';
    }
    if(event.target.classList.contains('nonLog')){
        document.getElementsByClassName('nonLog')[0].style.display = 'none';
    }
    if (event.target.classList.contains('baby-week-social-view')) {
        let ary = document.getElementsByClassName('sharing-options');
        for (let i = 0; i < ary.length; i++) {
            ary[i].style.display = 'none';
        }
        if (document.getElementsByClassName('sharing-options')[0]) {
            document.getElementsByClassName('sharing-options')[0].style.display = 'none';
        }
    }
}




